export class Constant {
		
		public static CONSTANT_API_local1 = 'http://13.202.251.155:81/Femtosoft/college_master_api_php/index.php/';
		// public static CONSTANT_API_local = 'http://localhost/college_master_api_php/index.php/';

// public static CONSTANT_API_local = 'https://stargls.in/college_master_api_php/index.php/';
public static CONSTANT_API_local = 'https://sricaargo.in/college_master_api_php/index.php/';
		// public static CONSTANT_API_universal = 'http://45.118.160.218/universal_transport/universal_api/index.php/';
		// public static CONSTANT_API_local = 'http://localhost/universal_api/index.php/';
		
		// public static CONSTANT_API_unique = 'http://13.202.251.155:81/Unique_Logistics/Unique_api_php/index.php/';

}
